// extracted by mini-css-extract-plugin
export default {"container":"TableHeaderColumn__container-BxuDJ","sortable":"TableHeaderColumn__sortable-oRvHq"};